import script from "./RcIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcIcon.vue?vue&type=script&setup=true&lang=ts"

import "./RcIcon.vue?vue&type=style&index=0&id=7319e995&lang=scss&scoped=true"

import exportComponent from "../../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7319e995"]])

export default __exports__